import React, { useState } from 'react';
import PropTypes from 'prop-types';
import VideoFilterContent from 'admin/views/videos/index/filter-content';
import cx from 'classnames'

const Filters = ({
   resources,
   onFilterChange,
   desktopType,
   onClearAllFilters,
   emptyFilters,
   filters,
   hasAccess,
   countesState,
   screenWidth,
   isReorderMode,
   contentType,
   isInsideModal,
}) => {

   const [searchValue, setSearchValue] = useState(filters?.search || '')
   return (
      <div
         onClick={ !hasAccess ? (e) => {
            e.preventDefault()
            e.stopPropagation()
         } : null }
         role='presentation'
         style={ hasAccess ? {} : {
            pointerEvents: 'none',
            opacity: '50%',
         } }
         className={
            cx({
               'flex items-start w-full justify-between sm:flex-wrap flex-nowrap px-6 max-lg:px-4 gap-2': true,
               '!flex-col !items-start': screenWidth <= 1024,
            })
         }
         id='recorded_streams-filters-container'
      >
         <VideoFilterContent
            onFilterChange={ (...arg) => {
               // setFilterType('filter');
               onFilterChange(...arg, 'filter')
            } }
            resources={ resources }
            desktopType={ desktopType }
            onClearAllFilters={ () => {
               // setFilterType(searchValue)
               onClearAllFilters(searchValue)
            } }
            emptyFilters={ emptyFilters }
            filtersData={ filters }
            type='livestream'
            countesState={ countesState }
            isReorderMode={ isReorderMode }
            contentType={ contentType }
            isInsideModal={ isInsideModal }
            onSearchChange={ (value) => {
               setSearchValue(value);
               // setFilterType(value)
               onFilterChange(value, 'search', value)
            } }
            isMobile={ screenWidth <= 1024 }
         />
      </div>
   )
};

Filters.propTypes = {
   resources: PropTypes.object,
   onFilterChange: PropTypes.func,
   onClearAllFilters: PropTypes.func,
   desktopType: PropTypes.string,
   emptyFilters: PropTypes.bool,
   hasAccess: PropTypes.bool,
   filters: PropTypes.object,
   countesState: PropTypes.object,
   screenWidth: PropTypes.number,
   isReorderMode: PropTypes.bool,
   contentType: PropTypes.string,
   isInsideModal: PropTypes.bool,
};
Filters.defaultProps = {
   resources: {},
   onFilterChange: () => {},
   onClearAllFilters: () => {},
   isReorderMode: false,
   contentType: '',
};

export default React.memo(Filters);
